const pl = {
    "sc_title": "Centrum bezpieczeństwa",
    "sc_subtitle": "Zintegrowana warstwa zabezpieczeń GaiaShield",
    "sc_tab_status": "🛡️ Stan ochrony",
    "sc_tab_events": "📋 Dziennik bezpieczeństwa",
    "sc_tab_node": "⚙️ Bezpieczeństwo węzła",
    "sc_loading": "Ładowanie danych bezpieczeństwa...",
    "sc_status_secured": "Stan systemu: Konto jest chronione",
    "sc_status_warning": "Stan systemu: Ostrzeżenia aktywne",
    "sc_desc_secured": "Brak aktywnych krytycznych ostrzeżeń. GaiaShield aktywnie monitoruje Twoje konto.",
    "sc_desc_warning": "Uwaga: Istnieją aktywne zdarzenia bezpieczeństwa, które wymagają Twojej uwagi.",
    "sc_account_protection": "Ochrona konta",
    "sc_message_protection": "Ochrona wiadomości",
    "sc_audits": "Audyty bezpieczeństwa",
    "sc_active": "AKTYWNY",
    "sc_failed_logins": "Nieudane logowania",
    "sc_tamper_checks": "Kontrole manipulacji",
    "sc_blocked_replays": "Zablokowane powtórzenia",
    "sc_last_check": "Ostatnia kontrola",
    "sc_just_now": "Przed chwilą",
    "sc_open_warnings": "Otwarte ostrzeżenia",
    "sc_btn_acknowledge": "Potwierdź",
    "sc_filter_severity": "Poziom ważności",
    "sc_filter_category": "Kategoria",
    "sc_filter_hide_ack": "Ukryj potwierdzone",
    "sc_btn_export": "Eksportuj",
    "sc_col_details": "Szczegóły",
    "sc_col_time": "Czas",
    "sc_col_status": "Status",
    "sc_col_action": "Akcja",
    "sc_no_events": "Nie znaleziono zdarzeń bezpieczeństwa.",
    "sc_node_title": "Konsola bezpieczeństwa operatora węzła",
    "sc_system_health": "Stan systemu",
    "sc_last_audit": "Ostatni audyt",
    "sc_packed_logs": "Spakowane dzienniki",
    "sc_unconfirmed_events": "Niepotwierdzone zdarzenia",
    "sc_operator_action": "Wymagana akcja operatora",
    "sc_all_ok": "Wszystko w porządku",
    "sc_critical_events": "Krytyczne zdarzenia systemowe",
    "ac_title": "Centrum zarządzania i zgłoszeń",
    "ac_subtitle": "Konsensus dotyczący zarządzania i zgłoszeń GaiaCom",
    "ac_tab_my_reports": "Moje zgłoszenia",
    "ac_tab_queue": "Kolejka recenzji",
    "ac_tab_operator": "Operator węzła",
    "ac_tab_transparency": "Federacja i przejrzystość",
    "ac_loading": "Ładowanie danych...",
    "ac_reported_cases": "Zgłoszone przypadki",
    "ac_no_reports": "Nie przesłałeś jeszcze żadnych zgłoszeń.",
    "ac_case_details": "Szczegóły sprawy",
    "ac_appeal_submit": "Złóż odwołanie",
    "ac_appeal_status": "Status odwołania",
    "ac_appeal_reason": "Powód odwołania",
    "ac_appeal_statement": "Oświadczenie",
    "ac_btn_appeal": "Wyślij odwołanie",
    "ac_trusted_reviewer_queue": "Kolejka zaufanych recenzentów",
    "ac_case_review": "Przejrzyj sprawę",
    "ac_review_category": "Zalecana kategoria",
    "ac_review_severity": "Zalecany poziom ważności",
    "ac_review_action": "Zalecana akcja",
    "ac_review_reason": "Powód recenzenta",
    "ac_btn_submit_review": "Prześlij recenzję",
    "ac_node_operator_dashboard": "Panel operatora węzła",
    "ac_apply_action": "Zastosuj akcję (Zastąp)",
    "ac_target_type": "Typ docelowy",
    "ac_target_id": "Identyfikator docelowy (GaiaID lub ID kanału)",
    "ac_suspend": "Zawieszenie aktywne",
    "ac_reason": "Oficjalny powód",
    "ac_btn_apply": "Egzekwuj akcję",
    "ac_transparency_title": "Dziennik konsensusu i przejrzystości",
    "ac_transparency_desc": "Publicznie widoczne dowody migawek wszystkich moderowanych kanałów i tożsamości.",
    "ac_btn_snapshot": "Utwórz migawkę przejrzystości",
    "search_placeholder": "Szukaj wiadomości według tematu, nadawcy, treści...",
    "abuse_center_title": "Centrum zgłaszania nadużyć",
    "abbrechen": "Anulować",
    "active_identities": "Aktywne tożsamości",
    "active_identity": "Aktywna tożsamość",
    "add_btn": "Dodać",
    "add_contact_title": "Dodaj kontakt",
    "admin": "Administrator",
    "adressbuch": "informator",
    "aktiviert": "Włączony",
    "an": "Do",
    "anonymous_sender": "Anonimowy nadawca",
    "antworten": "Odpowiedź",
    "attachment_gaia_hint": "Załączniki GaiaCOM pozostają w pełni zaszyfrowane.",
    "attachment_smtp_hint": "Starsza wersja protokołu SMTP blokuje załączniki wykonywalne/skryptowe i zapisuje wiadomości e-mail jako niebezpieczne.",
    "attachments": "Załączniki",
    "auffaellig": "Zauważalny",
    "auth_beta_notice": "Faza testów beta: GaiaCOM jest aktywnie testowany. Mogą wystąpić błędy; zabezpiecz ważne nasiona i dokładnie przejrzyj poufne przepływy pracy.",
    "auth_btn_login": "Załaduj tożsamość i zaloguj się",
    "auth_btn_register": "Zarejestruj się i utwórz kryptowalutę",
    "auth_copied": "Skopiowano",
    "auth_copy_seed": "Skopiuj ziarno",
    "auth_generate_seed": "Generuj nasiona",
    "auth_headline": "GaiaCOM to pierwszy kwantowo bezpieczny protokół poczty elektronicznej i system komunikacji zbudowany dla ludzkości.",
    "auth_kicker": "Bezpieczna komunikacja post-kwantowa",
    "auth_mnemonic": "Wyrażenie mnemoniczne",
    "auth_mnemonic_placeholder": "12 słów oddzielonych spacjami...",
    "auth_password": "hasło",
    "auth_password_placeholder": "•••••••••·•••",
    "auth_proof_e2ee_desc": "Klucze prywatne nie opuszczają Twojego urządzenia. Tylko zamierzeni odbiorcy mogą odszyfrować treść.",
    "auth_proof_gaiadata_desc": "Wiedza zerowa: zachowujesz kontrolę nad swoimi danymi. Metadane są zminimalizowane i nie są używane jako profil zwykłego tekstu.",
    "auth_proof_gaiadrop_desc": "Osoby z zewnątrz mogą wysyłać poufne wiadomości tekstowe na Twój GaiaID bez posiadania konta.",
    "auth_proof_gaiaproof_desc": "Dowody dostarczenia i integralności wskazują, że szyfrogram, nadawca i znacznik czasu nie zostały naruszone.",
    "auth_proof_gaiavault_desc": "Prywatne notatki, notatki dotyczące odzyskiwania i zapisy bezpieczeństwa pozostają lokalnie zaszyfrowane.",
    "auth_proof_hybrid_desc": "Quantum Shield: szyfrowanie hybrydowe za pomocą ML-KEM i X25519 chroni przed współczesnymi atakami i zagrożeniami typu: przechowuj teraz, odszyfruj, później.",
    "auth_secure_mail": "Bezpieczna poczta federacyjna Quantum",
    "auth_subline": "GaiaCOM to kwantowo bezpieczny system komunikacji dla poczty elektronicznej, czatów, pokojów kryzysowych, GaiaDrop i lokalnych plików bezpieczeństwa. Klucze prywatne pozostają na Twoim urządzeniu, treść jest kompleksowo szyfrowana, a dowody można eksportować bez zwykłego tekstu.",
    "auth_success_btn": "Zaloguj się teraz",
    "auth_success_text": "Twoje konto GaiaCOM zostało utworzone. Klucze zostały wygenerowane lokalnie z Twojego materiału siewnego i nie były przechowywane na serwerze.",
    "auth_success_title": "Rejestracja przebiegła pomyślnie",
    "auth_tab_drop": "GaiaDrop",
    "auth_tab_login": "Zaloguj się/Konto",
    "auth_toggle_login": "Konto już istnieje",
    "auth_toggle_register": "Utwórz nowe konto",
    "auth_usecase_text": "Odpowiedni dla prawników, firm, władz, dziennikarzy, sygnalistów i prywatnych spraw związanych z bezpieczeństwem.",
    "auth_usecase_title": "Zbudowany z myślą o wrażliwej komunikacji",
    "auth_username": "nazwa użytkownika",
    "auth_username_placeholder": "Wpisz nazwę...",
    "auth_value_chat": "Czat E2E",
    "auth_value_drop": "Bezpieczny zrzut",
    "auth_value_mail": "Bezpieczna poczta",
    "auth_value_rooms": "Pokoje Gaia",
    "bestaetigen": "Potwierdzać",
    "bestaetigt": "Potwierdzony",
    "bio_status": "Biografia/status",
    "biography": "biografia",
    "change_password_desc": "Zmienia hasło logowania po stronie serwera. Twoja lokalna fraza odzyskiwania pozostaje oddzielnie chroniona hasłem skarbca/odblokowania.",
    "change_password_menu_desc": "Zaktualizuj hasło logowania GaiaCOM.",
    "change_password_title": "Zmień hasło",
    "channel_id": "Identyfikator kanału",
    "channel_name_label": "Nazwa kanału",
    "chat_deleted_hidden": "Czat usunięty i ukryty.",
    "chat_input_placeholder": "Wpisz bezpieczną wiadomość...",
    "chat_start_hint": "Rozpocznij rozmowę! Wszystkie wiadomości na czacie są szyfrowane kwantowo E2E.",
    "choose_avatar": "Wybierz awatar",
    "ciphertext_hash": "Hash tekstu zaszyfrowanego",
    "clear_chat": "Pusty czat",
    "clear_for_everyone": "Puste dla wszystkich",
    "clear_for_me": "Puste, tylko dla mnie",
    "click_to_write_mail": "Kliknij, aby napisać e-mail",
    "click_top_right": "Kliknij w prawym górnym rogu",
    "close": "Zamknąć",
    "code_kopieren": "Skopiuj kod",
    "code_kopieren_success": "Kod skopiowany",
    "confirm_clear_channel_desc": "Czy chcesz usunąć ten kanał z widoku lokalnego?",
    "confirm_clear_channel_title": "Pusty kanał",
    "confirm_clear_chat": "Czy chcesz opróżnić ten czat?",
    "confirm_clear_chat_desc": "Czy chcesz opróżnić ten czat?",
    "confirm_clear_chat_title": "Pusty czat",
    "confirm_clear_everyone": "Czy chcesz opróżnić czat dla obu partnerów? (OK = dla wszystkich, Anuluj = tylko dla mnie)",
    "confirm_delete_everyone": "Czy chcesz usunąć wiadomość dla obu partnerów? (OK = dla wszystkich, Anuluj = tylko dla mnie)",
    "confirm_delete_msg": "Czy chcesz usunąć tę wiadomość?",
    "confirm_delete_msg_desc": "Czy chcesz usunąć tę wiadomość na czacie?",
    "confirm_delete_msg_title": "Usuń wiadomość",
    "confirm_new_password": "Potwierdź nowe hasło",
    "copy": "Kopia",
    "create_btn": "Tworzyć",
    "create_channel_title": "Utwórz kanał",
    "create_group_is_crisis": "Oznacz jako obszar kryzysowy",
    "create_group_title": "Utwórz nową grupę",
    "crypto_lock_desc": "Kontroluje, kiedy GaiaCOM usuwa lokalne klucze kryptograficzne z pamięci.",
    "crypto_lock_menu_desc": "Kontroluj liczniki przeładowania i braku aktywności.",
    "crypto_lock_title": "Zamek kryptograficzny",
    "crypto_session_duration": "Odblokowane po przeładowaniu",
    "crypto_session_duration_desc": "Utrzymuje sesję kryptograficzną otwartą w tej karcie przeglądarki tylko przez wybrany czas.",
    "cryptographic_fingerprint": "Kryptograficzny odcisk palca",
    "current_password": "Aktualne hasło",
    "data_minimization": "Minimalizacja danych",
    "decrypt_failed": "Nie do rozszyfrowania",
    "delete": "Usuwać",
    "delete_account_button": "Usuń konto nieodwołalnie",
    "delete_account_confirm_label": "Wpisz USUŃ, aby potwierdzić",
    "delete_account_confirmation_error": "Wymagane jest hasło i potwierdzenie USUŃ.",
    "delete_account_desc": "Ten tryb trwale niszczy Twoje konto, tożsamość, sesje urządzeń, dane GaiaDrop, przesłane metadane i wiadomości przypisane po stronie serwera.",
    "delete_account_done_desc": "Wszystkie możliwe do przypisania dane GaiaCOM zostały usunięte.",
    "delete_account_done_title": "Konto usunięte",
    "delete_account_menu_desc": "Zniszcz konto i powiązane dane.",
    "delete_account_not_authenticated": "Brak aktywnego konta.",
    "delete_account_title": "Usuń konto",
    "delete_for_everyone": "Usuń dla wszystkich",
    "delete_for_me": "Usuń tylko dla mnie",
    "device_current": "To urządzenie",
    "device_last_seen": "Ostatni",
    "device_logout": "Wyloguj się",
    "device_sessions_desc": "Sprawdź aktywne sesje i wyrejestruj urządzenia, którym już nie ufasz.",
    "device_sessions_empty": "Nie znaleziono żadnych urządzeń.",
    "device_sessions_menu_desc": "Zarządzaj i kończ aktywne sesje.",
    "device_sessions_title": "Zarejestrowane urządzenia",
    "device_since": "Od",
    "display_name": "Nazwa wyświetlana",
    "drop_address_copied": "Skopiowano adres GaiaDrop.",
    "drop_btn_decrypting": "Trwa odszyfrowywanie skrzynki odbiorczej...",
    "drop_btn_load": "Załaduj skrzynkę odbiorczą GaiaDrop",
    "drop_delete_desc": "Czy na pewno chcesz trwale usunąć tę kroplę?",
    "drop_delete_title": "Usuń GaiaDrop",
    "drop_desc": "Kanał zrzutu wiedzy o zerowej wiedzy składający się wyłącznie z tekstu, umożliwiający przesyłanie powiadomień zewnętrznych, odpowiedzialnego ujawniania informacji i poufnych raportów. Strony zewnętrzne mogą wysyłać wiadomości bez konta, korzystając z Twojego GaiaID.",
    "drop_empty": "Nie załadowano jeszcze żadnych wiadomości GaiaDrop.",
    "drop_id": "Identyfikator upuszczenia:",
    "drop_own_address": "Twój adres GaiaDrop",
    "drop_proof": "Odporność na upadki",
    "drop_title": "Bezpieczna skrzynka odbiorcza GaiaDrop",
    "dunkler_modus": "Tryb ciemny",
    "e2e_chat_room_open": "Otwórz pokój rozmów E2E",
    "edit_profile": "Edytuj profil",
    "edit_profile_desc": "Dostosuj nazwę wyświetlaną, biografię i awatar.",
    "einladungscode": "Kod zaproszenia",
    "enter_fingerprint_chars_confirm": "Wprowadź żądane znaki odcisków palców, aby potwierdzić.",
    "envelope_hash": "Hash koperty",
    "erasability": "Wymazywalność",
    "erfolg": "Sukces",
    "exclude_plaintext": "Eksportuj bez zwykłego tekstu",
    "export_disclosure": "Eksportuj obudowę zabezpieczającą",
    "export_package_desc": "Dołącz zwykły tekst tylko wtedy, gdy ujawnienie jest zamierzone.",
    "export_package_title": "Eksportuj pakiet zabezpieczeń",
    "fehler": "Błąd",
    "gaiacom_reader": "Czytnik GaiaCOM",
    "gaiadrop_inbox_title": "Skrzynka odbiorcza GaiaDrop",
    "gaiavault": "GaiaVault",
    "gaiadrive": "GaiaDrive",
    "gdpr_home_desc": "GaiaCOM minimalizuje metadane, przechowuje klucze prywatne lokalnie, szyfruje zawartość od początku do końca i umożliwia całkowite usunięcie konta.",
    "gdpr_home_title": "100% zgodności z RODO",
    "gdpr_reason_delete": "Usunięcie konta powoduje usunięcie konta, tożsamości, sesji lokalnych i danych, które można przypisać po stronie serwera.",
    "gdpr_reason_e2ee": "Treści prywatne można odszyfrować tylko dla zamierzonych odbiorców.",
    "gdpr_reason_minimal": "Metadane są wykorzystywane wyłącznie do celów routingu, dostarczania i zabezpieczeń.",
    "gdpr_reason_zero_knowledge": "Klucze prywatne i dane odzyskiwania pozostają lokalnie pod kontrolą użytkownika.",
    "gesendet": "Wysłano",
    "gesperrt_verdaechtig": "Zablokowany / Podejrzany",
    "group_delete_desc": "Czy na pewno chcesz trwale usunąć tę grupę? Wszystkie kanały i wiadomości w tej grupie zostaną usunięte.",
    "group_delete_title": "Usuń grupę",
    "group_description": "Opis",
    "group_icon_label": "Ikona/awatar grupy",
    "group_name": "Nazwa grupy",
    "group_settings_avatar": "Awatara",
    "group_settings_desc": "Opis",
    "group_settings_is_crisis": "Oznacz jako obszar kryzysowy",
    "group_settings_name": "Nazwa grupy",
    "group_settings_title": "Ustawienia grupy",
    "groups_empty_desc": "Stwórz bezpieczną przestrzeń do pracy dla projektu, kryzysu lub komunikacji w zespole.",
    "groups_empty_title": "Nie ma jeszcze czatów grupowych",
    "gruppe_beitreten": "Dołączyła do grupy",
    "gruppe_erstellen": "+ Utwórz grupę",
    "gruppe_verlassen": "Opuść grupę",
    "gruppen_chats": "Czaty grupowe",
    "heller_modus": "Tryb jasny",
    "how_to_receive_drops": "Jak otrzymać dropy?",
    "identitaets_assistent": "Asystent tożsamości",
    "inactivity_lock_duration": "Zablokuj, gdy jest nieaktywny",
    "inactivity_lock_duration_desc": "Po tym okresie braku danych GaiaCOM zostanie automatycznie zablokowany kryptograficznie.",
    "inactivity_lock_notice": "GaiaCOM został kryptograficznie zablokowany z powodu braku aktywności.",
    "include_plaintext": "Dołącz zwykły tekst",
    "invite_code_label": "Kod zaproszenia",
    "join_group_title": "Dołącz do grupy",
    "kanaele": "Kanały",
    "kanal_erstellen": "+ kanał",
    "kein_chat_ausgewaehlt": "Nie wybrano czatu",
    "kein_kanal_ausgewaehlt": "Nie wybrano kanału",
    "keine_gruppe_ausgewaehlt": "Nie wybrano grupy",
    "keine_mails": "Brak dostępnych e-maili.",
    "key_change_warn_desc": "Klucz publiczny tego kontaktu uległ zmianie. Zanim zaufasz, sprawdź odcisk palca.",
    "key_change_warn_title": "Ostrzeżenie kryptograficzne",
    "key_change_warning_changed": "się zmieniło. Może to być oznaką ataku typu man-in-the-middle!",
    "key_change_warning_msg": "Klucz tożsamości kontaktu",
    "key_transparency": "Kluczowa przejrzystość",
    "kopiert": "Skopiowano",
    "kryptographische_schluessel": "Klucze kryptograficzne",
    "kryptographische_schluessel_desc": "Pokaż klucze prywatne i kopię zapasową frazy początkowej.",
    "laden": "Obciążenie...",
    "leeren": "Pusty",
    "loading": "Obciążenie...",
    "local_key_vault": "Lokalny magazyn kluczy",
    "local_keys_label": "Klucze lokalne",
    "lock_on_reload": "Zawsze blokuj po przeładowaniu",
    "logout": "Wyloguj się",
    "mail_compose": "Napisz e-mail",
    "mein_profil": "Mój profil",
    "melden": "Raport",
    "menu": "menu",
    "message": "Aktualności",
    "message_id": "Identyfikator wiadomości",
    "message_pin": "Szpilka",
    "message_pinned_title": "Przypięte wiadomości",
    "message_react": "Zareagować",
    "message_reply": "Odpowiedź",
    "message_replying_to": "Odpowiedź na",
    "message_save": "Ratować",
    "message_saved": "Zapisano",
    "message_to_channel": "Wiadomość do",
    "message_unpin": "Rozwiązywać",
    "message_unsave": "Nie oszczędzaj",
    "mitglied": "Członek",
    "mitglieder": "członkowie",
    "ml_kem": "ML-KEM",
    "neue_mail": "Nowy e-mail",
    "never_auto_lock": "Nigdy automatycznie",
    "new_fingerprint": "Nowy odcisk palca",
    "new_identity": "Nowa tożsamość",
    "new_password": "Nowe hasło",
    "no_description": "Brak opisu",
    "no_key_history": "Nie zapisano historii kluczy.",
    "no_specification": "Nie określono",
    "old_fingerprint": "Stary odcisk palca",
    "open_privacy_imprint": "Otwarty nadruk i ochrona danych",
    "post_quantum_e2e": "Postkwantowa E2E",
    "posteingang": "Skrzynka odbiorcza",
    "powered_by": "Obsługiwane przez",
    "privacy_imprint_menu_desc": "Pokaż RODO, ochronę danych i notę ​​prawną.",
    "privacy_imprint_profile_desc": "GaiaCOM przetwarza treści komunikacyjne zgodnie z zasadami minimalizacji danych, kompleksowego szyfrowania i lokalnej kontroli kluczy.",
    "privacy_imprint_title": "Ochrona danych i informacja prawna",
    "profil": "profil",
    "profile_details": "Szczegóły profilu",
    "profile_settings_hint": "Ustawienia profilu są wyświetlane w prawym panelu.",
    "profile_unlock_desc": "Ze względów bezpieczeństwa musisz ponownie wprowadzić hasło, aby wyświetlić prywatne klucze kryptograficzne.",
    "proof_hash": "Hash dowodu:",
    "public_drop_desc": "Bezpieczny spadek zewnętrznych informacji tekstowych bez konta GaiaCOM.",
    "public_drop_message": "Aktualności",
    "public_drop_message_placeholder": "Wpisz poufny tekst...",
    "public_drop_send": "Wyślij GaiaDrop",
    "public_drop_sender": "Notatka nadawcy opcjonalna",
    "public_drop_sender_placeholder": "Imię i nazwisko, numer pliku lub anonimowe",
    "public_drop_target": "Docelowy GaiaID",
    "quanten_chat": "Kwantowy czat",
    "quantum_secure_exchange": "Kwantowo bezpieczna wymiana poprzez...",
    "quantum_secure_net": "Bezpieczna sieć GaiaCOM Quantum (Ed25519 i ML-KEM)",
    "quantum_shield_desc": "Sieć GaiaCOM chroni Twoją prywatność za pomocą wielowarstwowego, hybrydowego protokołu szyfrowania, który jest chroniony przed atakami ze strony przyszłych komputerów kwantowych.",
    "quantum_shield_l1_desc": "Wykorzystuje standard FIPS 203 do hermetyzacji symetrycznego klucza współdzielonego. Zapobiega pasywnemu nagrywaniu i późniejszemu odszyfrowaniu („Przechowuj teraz, odszyfruj później”) przez komputery kwantowe.",
    "quantum_shield_l1_title": "1. Ochrona pokwantowa (ML-KEM-1024)",
    "quantum_shield_l2_desc": "Klasyczna, niezwykle szybka procedura wymiany kluczy Diffiego-Hellmana, stanowiąca dodatkową warstwę bezpieczeństwa w procedurze hybrydowej.",
    "quantum_shield_l2_title": "2. Kryptografia krzywych eliptycznych (X25519)",
    "quantum_shield_l3_desc": "Każda wiadomość i każda koperta Federacji jest podpisana kryptograficznie, aby jednoznacznie zweryfikować autentyczność nadawcy.",
    "quantum_shield_l3_title": "3. Podpisy cyfrowe (Ed25519)",
    "quantum_shield_l4_desc": "Szyfruje treść wiadomości symetrycznie i ściśle wiąże nadawcę, odbiorcę i metadane z uwierzytelnionymi danymi dodatkowymi (AAD), aby zapobiec atakom polegającym na ponownym odtwarzaniu.",
    "quantum_shield_l4_title": "4. Uwierzytelnianie AAD (AES-256-GCM)",
    "quantum_shield_status": "Stan Tarczy Kwantowej",
    "receive_drops_step1": "Udostępnij swój identyfikator GaiaID (np. za pomocą przycisku kopiowania powyżej) źródłom zewnętrznym.",
    "receive_drops_step2": "Wywołują one stronę logowania Twojej instancji GaiaCOM i przełączają do zakładki",
    "receive_drops_step3": "i wyślij zaszyfrowaną wiadomość na swój adres.",
    "receiver_gaia": "Odbiornik GaiaCOM",
    "receiver_smtp": "Odbiorca SMTP",
    "records_stored": "Zapisy zapisane",
    "refresh": "Aktualizacja",
    "report_abuse_desc": "Czy chcesz zgłosić tę wiadomość i przesłać na serwer kryptograficzny dowód nadużycia?",
    "report_abuse_title": "Zgłoś nadużycie",
    "reputation_status": "Stan reputacji",
    "room_chat_start_hint": "Rozpocznij rozmowę! Wszystkie wiadomości w tym kanale grupowym są zdecentralizowane, szyfrowane kwantowo E2E.",
    "room_policy_audit": "Ścieżka audytu i rotacja kluczy są aktywne.",
    "room_policy_crisis": "Pokój kryzysowy",
    "room_policy_e2ee": "Przestrzeń wiedzy zerowej. Bezpieczny kwantowo E2EE.",
    "room_policy_title": "Wytyczne dotyczące pokoju",
    "room_policy_zero_knowledge": "Polityka",
    "room_security_note_desc": "Wszystkie kluczowe zmiany są sprawdzane za pomocą funkcji Key Transparency. Użyj GaiaVault do tworzenia prywatnych kopii zapasowych dzienników.",
    "room_security_note_title": "Przypięta notatka dotycząca bezpieczeństwa",
    "save_profile": "Zapisz profil",
    "schluessel_entsperrt": "🔑Zablokuj ponownie klucz",
    "search_gaia_label": "Znajdź adres Gai",
    "security_warning_title": "Ostrzeżenie dotyczące bezpieczeństwa",
    "select_channel_chat": "Wybierz kanał z lewego paska bocznego, aby porozmawiać.",
    "select_contact_chat": "Wybierz kontakt z lewego panelu, aby rozpocząć bezpieczny czat E2E.",
    "select_mail_read": "Wybierz wiadomość e-mail z listy, aby przeczytać jej zawartość bezpieczną kwantowo lub utwórz nową wiadomość.",
    "senden": "Wysłać",
    "sender_signature": "Podpis nadawcy",
    "server_log": "Dziennik serwera:",
    "server_received": "Serwer odebrany",
    "session_lock": "Blokada sesji",
    "setup_address_keys": "Utwórz adres i zestaw kluczy",
    "setup_profile": "Skonfiguruj w profilu",
    "smtp_inbox_title": "Odbiór SMTP",
    "smtp_legacy_badge": "Starszy SMTP / Niebezpieczny",
    "smtp_mode_option": "Starszy most SMTP",
    "smtp_security_warning": "Ten e-mail został przesłany klasycznym, niezaszyfrowanym protokołem SMTP. Brak aktywnego szyfrowania typu end-to-end.",
    "smtp_security_warning_desc": "Ta wiadomość opuszcza pokój bezpieczeństwa GaiaCom. Dostawa SMTP nie zapewnia kompleksowej gwarancji GaiaCom, gwarancji TrustMesh ani gwarancji Godmode z bramy.",
    "spam_verdacht": "Spam/podejrzenie",
    "spam_warning_desc": "Ta wiadomość zawiera podejrzane sygnały dotyczące reputacji.",
    "spam_warning_title": "Ostrzeżenie o spamie",
    "speichern": "Ratować",
    "sperren": "Zastosować lokaut",
    "standard_group_status": "Standardowy czat grupowy (szyfrowany E2EE)",
    "status": "status",
    "subject": "W sprawie",
    "suchen": "Znajdź nowy adres Gaia...",
    "tage": "dni",
    "time_unknown": "Czas nieznany",
    "transmission_mode": "Tryb transferu",
    "trust_age": "Zaufaj wiekowi",
    "trust_passport_title": "Zaufaj paszportowi",
    "unbestaetigt": "Niepotwierdzone",
    "unknown_sender": "Nieznany",
    "unlock_btn": "Odblokować",
    "unlock_btn_profile": "Odblokować",
    "unlock_desc": "Twój plik klucza prywatnego jest przechowywany w postaci zaszyfrowanej. Wprowadź swoje hasło, aby załadować klucze kryptograficzne wyłącznie do pamięci.",
    "unlock_logout": "Wyloguj się i zamknij klucze lokalne",
    "unlock_title": "Odblokuj tożsamość",
    "untrusted": "Nie godny zaufania",
    "update_password": "Zaktualizuj hasło",
    "upload_avatar_btn": "Prześlij obraz (oczyszczony)",
    "vault_btn_encrypt": "Zaszyfruj rekord",
    "vault_btn_lock": "Zablokuj sejf",
    "vault_btn_unlock": "Odblokuj sejf",
    "vault_copied_success": "Skopiowano do schowka",
    "vault_decrypted_content": "Odszyfrowana treść",
    "vault_desc": "Lokalny zaszyfrowany skarbiec do odzyskiwania kopii zapasowych, notatek identyfikacyjnych, dostępu do serwera, kontaktów awaryjnych, notatek prawnych, zdarzeń związanych z bezpieczeństwem i prywatnych dzienników.",
    "vault_empty": "Nie zapisano jeszcze żadnych bezpiecznych rekordów.",
    "vault_locked_pane_notice": "Sejf jest zamknięty. Proszę odblokować po prawej stronie.",
    "vault_new_record": "Nowy bezpieczny rekord",
    "vault_pwd_placeholder": "Wprowadź hasło do skarbca...",
    "vault_record_body": "Nagraj zawartość",
    "vault_record_body_placeholder": "Wprowadź zaszyfrowaną treść rekordu...",
    "vault_record_category": "kategoria",
    "vault_record_title": "Tytuł nagrania",
    "vault_record_title_placeholder": "Tytuł bezpiecznego zapisu",
    "vault_title": "Bezpieczne rekordy GaiaVault",
    "verify_new_fingerprint_hint": "Przed przyjęciem klucza sprawdź nowy odcisk palca.",
    "vertrauenswuerdig": "Godny zaufania",
    "vision_gaia_technology": "WizjaGaiaTechnologia",
    "von": "Z",
    "warnung": "ostrzeżenie",
    "wizard_address": "adres",
    "wizard_back": "Z powrotem",
    "wizard_check1": "Bezpiecznie uratowałem moje nasienie.",
    "wizard_custom_domain": "Użyj własnej domeny",
    "wizard_desc1": "GaiaCOM nie przechowuje kluczy prywatnych po stronie serwera. Bez Mnemonic Seed nikt nie będzie w stanie odzyskać utraconych wiadomości.",
    "wizard_desc2": "Twój adres określa węzeł stowarzyszony, przez który kierowane są zaszyfrowane koperty.",
    "wizard_fallback": "Węzły rezerwowe",
    "wizard_finish": "Zakończ konfigurację",
    "wizard_next": "Dalej",
    "wizard_server_domain": "Domena węzła serwera",
    "wizard_step1": "1. Zapasowe ziarno",
    "wizard_step2": "2. Adres i serwer",
    "wizard_title1": "Utwórz kopię zapasową klucza odzyskiwania",
    "wizard_title2": "Wybierz adres GaiaCOM",
    "write_message_placeholder": "Napisz bezpieczną wiadomość...",
    "you": "Ty",
    "zero_knowledge": "Zerowa wiedza",
    "zero_knowledge_encryption": "Szyfrowanie z wiedzą zerową",
    "Chat fuer alle geleert": "Czat został pusty dla wszystkich uczestników.",
    "Chat geleert": "Czat został wyczyszczony w Twojej lokalnej skrzynce odbiorczej.",
    "Nachricht fuer alle geloescht": "Wiadomość została usunięta w przypadku wszystkich uczestników.",
    "Nachricht geloescht": "Wiadomość czatu została usunięta lokalnie z Twojej skrzynki odbiorczej.",
    "anpinnen": "Szpilka",
    "chat_loeschen": "Usuń czat",
    "confirm_delete_chat_desc": "Czy na pewno chcesz usunąć i ukryć czat?",
    "confirm_leave_group_desc": "Czy na pewno chcesz opuścić tę grupę?",
    "entpinnen": "Odpiąć",
    "group_deleted": "Grupa została pomyślnie usunięta.",
    "group_left": "Opuść grupę pomyślnie.",
    "gruppe_loeschen": "Usuń grupę",
    "loeschen": "Usuwać",
    "no_active_chats": "Brak aktywnych czatów. Wyszukaj kontakty powyżej, aby rozpocząć czat.",
    "pinned": "Przypięty",
    "wizard_check_credentials": "Jestem odpowiedzialny za bezpieczeństwo moich danych dostępowych.",
    "wizard_check_is_beta": "Rozumiem, że GaiaCom jest oprogramowaniem w wersji beta.",
    "wizard_check_no_illegal": "Nie będę używać GaiaCom do celów niezgodnych z prawem.",
    "wizard_check_no_uptime": "Rozumiem, że nie ma gwarancji dostępności.",
    "wizard_check_smtp_security": "Rozumiem, że wiadomości SMTP nie zapewniają pełnego bezpieczeństwa GaiaCom.",
    "wizard_check_terms_read": "Zapoznałem się z Warunkami korzystania z usługi Beta.",
    "wizard_step_terms": "Warunki użytkowania",
    "wizard_terms_text": "Warunki korzystania z GaiaCom i umowa dotycząca testów beta (faza beta)\n\nDostawca: VisionGaiaTechnology (zwany dalej „Dostawcą”)\nStatus: Faza publicznych testów beta\nWażność: od 21 czerwca 2026 r\n\n⚠️ NAJWAŻNIEJSZA UWAGA Z WCZEŚNIEJ (PROSZĘ UWAŻNIE PRZECZYTAĆ)\nGaiaCom jest w fazie publicznych testów beta. Pomimo szeroko zakrojonych środków bezpieczeństwa nie można zagwarantować braku błędów, ciągłej dostępności ani całkowitego bezpieczeństwa oprogramowania i podstawowej infrastruktury. Używaj na własne ryzyko. Użytkownicy są odpowiedzialni za bezpieczne przechowywanie swoich danych dostępowych (w szczególności kluczy do GaiaVault) oraz za zgodność z obowiązującymi przepisami prawa.\n\n1. Przedmiot i cel fazy beta testów\n1.1. Cel świadczenia usługi: GaiaCom to nowatorska usługa poczty elektronicznej i czatu oparta na kryptografii postkwantowej (PQC). Udostępnienie w fazie beta jest przeznaczone wyłącznie do testów technicznych, symulacji obciążenia, wyszukiwania błędów programu (błędów) i optymalizacji przyjazności dla użytkownika.\n1.2. Status Beta: Użytkownik jest świadomy, że oferowane oprogramowanie jest wersją wstępną (oprogramowanie beta). Nie jest to jeszcze w pełni rozwinięte technicznie, nie spełnia standardów produktu końcowego, komercyjnego i może powodować błędy, utratę danych, opóźnienia w transmisji lub awarie systemu.\n1.3. Brak prawa do kontynuacji: Usługodawca ma prawo w dowolnym momencie zaprzestać świadczenia usługi w całości lub w części, zmienić lub ograniczyć funkcje lub usunąć je czasowo lub na stałe bez podania przyczyny.\n\n2. Dostępność i wyłączenie gwarancji\n2.1. Brak gwarancji dostępności: GaiaCom jest dostarczany bez żadnej gwarancji dostępności lub czasu pracy. Nie ma prawa do nieprzerwanej dostępności usługi.\n2.2. Wyłączenie gwarancji: Oprogramowanie jest dostarczane w obecnym stanie („takie, jakie jest”) i zależne od jego dostępności. W zakresie dozwolonym przez prawo wykluczone są wszelkie roszczenia z tytułu rękojmi za wady fizyczne i prawne oprogramowania. W szczególności nie ma gwarancji, że oprogramowanie jest wolne od błędów, szkodliwego oprogramowania lub nadaje się do określonego celu.\n\n3. Zarządzanie ryzykiem i obowiązki użytkowników\n3.1. Zakaz przechowywania danych krytycznych: Użytkownik zobowiązuje się nie przechowywać ani nie przesyłać za pośrednictwem GaiaCom wyłącznie danych o znaczeniu krytycznym dla działalności gospodarczej, istotnych, niezbędnych operacyjnie lub szczególnie wrażliwych z prawnego punktu widzenia (takich jak akta pacjentów, wysoce wrażliwe dane finansowe lub tajemnice urzędowe). Usługa nie może być wykorzystywana w infrastrukturze, w której nieprzewidziane awarie mogłyby skutkować obrażeniami ciała, szkodami w mieniu lub znaczącymi stratami finansowymi.\n3.2. Samodzielna kopia zapasowa: Użytkownik jest odpowiedzialny za tworzenie kopii zapasowych wszystkich danych otrzymanych lub wysłanych za pośrednictwem GaiaCom, których potrzebuje w dłuższej perspektywie, na swoich własnych, niezależnych systemach (kopie zapasowe). Dostawca nie gwarantuje trwałego przechowywania ani możliwości przywracania danych na swoich serwerach.\n\n4. Funkcje kryptograficzne i GaiaVault\n4.1. Kryptografia postkwantowa (PQC): GaiaCom wdraża najnowocześniejsze, przyszłościowe procesy szyfrowania, które mają wytrzymać ataki przyszłych komputerów kwantowych. Użytkownik ma jednak świadomość, że jest to dynamiczna i nowa dziedzina naukowa. Przy obecnym stanie nauki i technologii nie można zagwarantować absolutnego i niezaprzeczalnego bezpieczeństwa. Terminy takie jak „100% bezpieczne”, „nie do złamania” lub „bezpieczne militarnie” nie są wyraźnie gwarantowane.\n4.2. Brak gwarancji odzyskania danych (GaiaVault): GaiaCom opiera się na spójnej koncepcji bezpieczeństwa opartej na wiedzy zerowej. Kliny szyfrujące i dane dostępowe pozostają wyłącznie pod kontrolą użytkownika (zabezpieczone przez GaiaVault).\nWAŻNE: Jeśli użytkownik straci swoje hasła, hasła, klucze prywatne lub nasiona odzyskiwania, dostawca nie ma technicznych możliwości odtworzenia lub zresetowania tych danych. Utrata tych danych dostępowych nieuchronnie prowadzi do nieodwracalnej utraty dostępu do konta użytkownika i wszystkich danych w nim zaszyfrowanych.\n4.3. Jeszcze nie w pełni kontrolowane: oprogramowanie jest stale poddawane wewnętrznym kontrolom bezpieczeństwa, ale w fazie beta nie przeszło jeszcze ostatecznego, kompleksowego zewnętrznego audytu bezpieczeństwa przeprowadzanego przez niezależne instytucje testujące.\n\n5. Interfejsy, starsze protokoły i federacja\n5.1. Most SMTP Uwaga: GaiaCom oferuje możliwość komunikacji za pośrednictwem klasycznych protokołów e-mail (takich jak SMTP). Użytkownik jest świadomy, że wiadomości opuszczające rodzimy obszar bezpieczeństwa GaiaCom (np. wysłane na konwencjonalny adres @gmail.com lub @gmx.de) są przesyłane za pośrednictwem serwerów niezaszyfrowanych lub serwerów stron trzecich. Kompleksowe gwarancje bezpieczeństwa GaiaCom mają zastosowanie jedynie w ograniczonym zakresie lub w ogóle nie dotyczą takich starszych wiadomości wychodzących lub przychodzących z zewnątrz.\n5.2. Uwaga dotycząca federacji: Jeśli GaiaCom działa w sieci stowarzyszonej, wiadomości i dane mogą przechodzić przez serwery stron trzecich. Choć treść wiadomości pozostaje chroniona kompleksowym szyfrowaniem, metadane (takie jak godzina wysłania, adresy IP zaangażowanych serwerów i adresy odbiorców) mogą być technicznie widoczne dla operatorów tych serwerów stowarzyszonych. Dostawca nie ma wpływu na praktyki ochrony danych zewnętrznych operatorów serwerów w sieci stowarzyszonej.\n\n6. Dopuszczalne zastosowania i działania zabronione\nUżytkownik zobowiązuje się nie korzystać z usługi w sposób niewłaściwy lub niezgodny z prawem. W szczególności zabrania się:\n- Dystrybucja, wysyłanie lub hosting wirusów, złośliwego oprogramowania, treści phishingowych lub innego złośliwego oprogramowania.\n- Korzystanie z Usługi w celu przeprowadzania ataków typu „odmowa usługi” (DDoS) lub niechcianej wysyłki masowej (spamu).\n- Nadużywanie systemu w celu popełnienia oszustwa.\n- Dystrybucja lub wymiana nielegalnych treści, w szczególności przedstawiających niegodziwe traktowanie dzieci w celach seksualnych (CSAM), propagandę terrorystyczną, nawoływania do przemocy lub inne treści o charakterze karnym.\n\n7. System zgłaszania nadużyć\n7.1. Zgłaszanie nadużyć: Użytkownicy mają możliwość zgłaszania nadużyć w komunikacji lub nielegalnych działań za pośrednictwem zintegrowanego systemu nadużyć.\n7.2. Przetwarzanie raportów: W celu zapewnienia ochrony przed nadużyciami, przychodzące raporty mogą być analizowane technicznie (przy zachowaniu limitów prywatności i szyfrowania). Może to prowadzić do tymczasowego lub stałego zawieszenia kont użytkowników lub adresów IP w przypadku udowodnionego naruszenia niniejszych warunków użytkowania.\n\n8. Ograniczenie odpowiedzialności\n8.1. Standard odpowiedzialności: Oprogramowanie w wersji beta jest dostarczane bezpłatnie. Zgodnie z przepisami prawnymi dotyczącymi darowizn lub pożyczek usługodawca ponosi zatem odpowiedzialność wyłącznie za działanie umyślne (szkoda umyślna) i rażące niedbalstwo.\n8.2. Wyłączenie odpowiedzialności za utratę danych: Odpowiedzialność za utratę danych jest wykluczona, chyba że utrata została spowodowana umyślnie lub w wyniku rażącego niedbalstwa ze strony dostawcy, a użytkownik wywiązał się ze swojego obowiązku ograniczenia szkód poprzez regularne tworzenie kopii zapasowych (poza GaiaCom).\n8.3. Granice prawne: Powyższe ograniczenia odpowiedzialności nie dotyczą szkód na życiu, ciele i zdrowiu ani odpowiedzialności wynikającej z ustawy o odpowiedzialności za produkt.\n\n9. Otwarte źródło\nNiektóre komponenty, biblioteki lub aplikacje klienckie GaiaCom mogą być objęte licencjami typu open source (np. GPL, MIT, Apache). Niniejsze warunki użytkowania nie mają wpływu na odpowiednie warunki licencji tych komponentów i można je przeglądać w odpowiednich repozytoriach kodu źródłowego.\n\n10. Kontrola eksportu i zgodność\nUżytkownik jest świadomy, że oprogramowanie kryptograficzne może podlegać ścisłej kontroli eksportu i ograniczeniom prawnym. Użytkownik jest odpowiedzialny za zapewnienie, że korzystanie z GaiaCom nie narusza prawa, ograniczeń importowych/eksportowych lub przepisów kryptograficznych obowiązujących w jego kraju zamieszkania.\n\n11. Informacja o ochronie danych (wersja skrócona dla wersji beta)\n11.1. Minimalne gromadzenie danych: W ramach fazy beta dostawca gromadzi wyłącznie dane, które są absolutnie niezbędne do obsługi technicznej, rozwiązywania problemów i dalszego rozwoju (np. pliki dziennika serwera do diagnozowania błędów).\n11.2. Brak wglądu w treść: dzięki spójnej wiedzy zerowej i szyfrowaniu E2E dostawca nigdy nie ma dostępu do treści Twoich czatów, e-maili ani kluczy przechowywanych w GaiaVault.\n11.3. Szczegółowe oświadczenie o ochronie danych: Szczegółowe przepisy dotyczące ochrony danych są powiązane osobno i użytkownik musi je również wziąć pod uwagę przed rejestracją.\n\n12. Postanowienia końcowe\n12.1. Obowiązujące prawo: Obowiązuje prawo Republiki Federalnej Niemiec, z wyłączeniem Konwencji Narodów Zjednoczonych o umowach międzynarodowej sprzedaży towarów.\n12.2. Zastrzega się możliwość zmian: Ponieważ GaiaCom jest w fazie aktywnego rozwoju, dostawca zastrzega sobie prawo do dostosowania niniejszych warunków w dowolnym momencie ze skutkiem na przyszłość. Aktualna wersja dostępna jest w aplikacji.",
    "wizard_terms_title": "Warunki korzystania z GaiaCom i umowa dotycząca testów beta (faza beta)",
    "node_operator": "Operator węzła",
    "search_channels": "Wyszukaj kanały...",
    "senior_reviewer": "Starszy recenzent",
    "trusted_reviewer": "Zaufany recenzent",
    "active_frequencies": "Aktywne częstotliwości",
    "connected_rooms": "POŁĄCZONE PRZESTRZENIE",
    "dashboard": "Panel",
    "empty_chats": "Brak dostępnych aktywnych czatów.",
    "empty_messages": "Brak nowych wiadomości.",
    "encrypted": "Zaszyfrowane",
    "gaiacom_uplink": "ŁĄCZE GAIACOM",
    "install_app": "Zainstaluj aplikację",
    "install_app_desc": "Do szybkiego uruchamiania i trybu offline",
    "kommandozentrale_alpha": "Centrum dowodzenia ALFA",
    "network_online": "SIEĆ: ONLINE",
    "new_room": "Nowa przestrzeń",
    "no_frequencies_active": "Brak aktywnych częstotliwości. Utwórz nowy pokój, aby rozpocząć komunikację.",
    "no_id": "Brak identyfikatora",
    "open_chats": "Otwórz czaty",
    "open_inbox": "Otwórz skrzynkę odbiorczą",
    "primary_identity": "PODSTAWOWA TOŻSAMOŚĆ",
    "recent_chats": "Nowe czaty",
    "recent_messages": "Najnowsze wiadomości",
    "session_encrypted": "Sesja zaszyfrowana: {name}",
    "session_secure": "STATUS: BEZPIECZNY",
    "system_verlassen": "Wyjdź z systemu",
    "write_message": "Napisz wiadomość",
    "onboarding_step_profile": "Profil",
    "onboarding_step_security": "Ochrona",
    "onboarding_step_backup": "Kopia zapasowa",
    "onboarding_step_launch": "Start",
    "onboarding_loading_gaia_id": "Ładowanie Gaia-ID",
    "onboarding_setup_kicker": "Wstępna konfiguracja GaiaCom",
    "onboarding_profile_title": "Uczyń GaiaCom swoją własną przestrzenią.",
    "onboarding_profile_desc": "Twoja nazwa wyświetlana i awatar pozostają pod kontrolą lokalną i można je zmienić w profilu w dowolnym momencie.",
    "onboarding_security_title": "Co GaiaCom chroni dla Ciebie w tej chwili.",
    "onboarding_security_desc": "GaiaCom oddziela tożsamość, klucze, wiadomości i status sieci. Widzisz tutaj tylko krótkie podsumowanie.",
    "onboarding_backup_title": "Kopia zapasowa to Twoje prawdziwe wyjście awaryjne.",
    "onboarding_backup_desc": "Bez danych odzyskiwania nikt nie odzyska Twojej tożsamości. O to właśnie chodzi w prawdziwym bezpieczeństwie end-to-end.",
    "onboarding_launch_title": "Gotowy. Co chcesz zrobić najpierw?",
    "onboarding_launch_desc": "Możesz zacząć od razu lub zakończyć samouczek i kontynuować pracę w panelu.",
    "onboarding_display_name": "Nazwa wyświetlana",
    "onboarding_display_name_placeholder": "Jak GaiaCom ma Cię wyświetlać?",
    "onboarding_select_avatar": "Wybierz awatar",
    "onboarding_sec_identity_title": "Tożsamość",
    "onboarding_sec_identity_desc": "Twój Gaia-ID to Twój punkt odniesienia w sieci. Kontakty mogą wykryć zmianę kluczy.",
    "onboarding_sec_messages_title": "Wiadomości",
    "onboarding_sec_messages_desc": "Treść jest odszyfrowywana lokalnie. Edytowane wiadomości otrzymują nowe podpisy.",
    "onboarding_sec_network_title": "Sieć",
    "onboarding_sec_network_desc": "Centrum Bezpieczeństwa i Centrum Zgłoszeń pokazują ryzyka, bez globalnych backdoory.",
    "onboarding_sec_transparency_title": "Przejrzystość",
    "onboarding_sec_transparency_desc": "Zapisuje zdarzenia bezpieczeństwa w protokole, aby ostrzeżenia były możliwe do prześledzenia.",
    "onboarding_backup_notice_title": "Ważne dla zwykłych użytkowników",
    "onboarding_backup_notice_desc": "Zapisz swoje dane odzyskiwania oddzielnie od tego urządzenia. W przypadku utraty hasła i kopii zapasowej GaiaCom celowo pozostanie zablokowany.",
    "onboarding_backup_consent": "Wiem, że moja kopia zapasowa jest kluczowa do odzyskiwania i zmiany urządzenia.",
    "onboarding_inbox_title": "Skrzynka odbiorcza",
    "onboarding_inbox_desc": "Czytaj e-maile i napisz swoją pierwszą wiadomość.",
    "onboarding_contacts_title": "Kontakty",
    "onboarding_contacts_desc": "Sprawdź pierwszy kontakt lub rozpocznij czat.",
    "onboarding_channels_title": "Kanały",
    "onboarding_channels_desc": "Odkrywaj publiczne częstotliwości.",
    "onboarding_security_title_card": "Centrum Bezpieczeństwa",
    "onboarding_security_desc_card": "Wyświetl status GaiaShield.",
    "onboarding_later": "Później",
    "onboarding_back": "Wstecz",
    "onboarding_continue": "Dalej",
    "onboarding_complete_setup": "Zakończ konfigurację",
    "auth_legal_consent": "Przeczytałem i akceptuję politykę prywatności oraz warunki korzystania.",
    "auth_show_terms": "Pokaż warunki korzystania",
    "auth_recovery_mode": "Tryb odzyskiwania",
    "auth_recovery_import_title": "Importuj plik odzyskiwania",
    "auth_recovery_import_desc": "Przywróć swoje klucze GaiaCom z chronionego hasłem pliku kopii zapasowej. Następnie mnemonik i nazwa użytkownika zostaną automatycznie uzupełnione.",
    "auth_recovery_file_pwd_placeholder": "Hasło pliku odzyskiwania",
    "auth_recovery_local_pwd_placeholder": "Nowe lokalne hasło odblokowujące min. 12 znaków",
    "auth_recovery_importing": "Importowanie...",
    "auth_recovery_decrypt": "Odszyfruj odzyskiwanie",
    "auth_back_to_login": "Powrót do logowania",
    "auth_terms_title": "Warunki korzystania z GaiaCom Beta",
    "auth_terms_close": "Zamknij",
    "auth_cookie_title": "GaiaCOM zachowuje suwerenność.",
    "auth_cookie_desc": "Używamy tylko technicznie niezbędnej pamięci lokalnej do obsługi języka, sesji i bezpieczeństwa. Brak śledzenia, reklamowych plików cookie czy profilowania przez firmy trzecie.",
    "auth_cookie_accept": "Rozumiem",
    "sc_explainer_title": "Co tak naprawdę jest tutaj chronione?",
    "sc_explainer_desc": "GaiaShield to warstwa ochronna między Twoim kontem, Twoimi wiadomościami a siecią. Nie decyduje o treściach, lecz o ryzykach technicznych: manipulacjach, próbach ponownego wysłania, nieautoryzowanym dostępie, podejrzanych wzorcach logowania i niebezpiecznych przejściach bramowych.",
    "sc_explainer_identity_desc": "Sprawdza anomalie logowania, ryzyka sesji i dostęp do innych tożsamości.",
    "sc_explainer_messages_desc": "Wykrywa próby ponownego wysłania, zmanipulowane koperty i brak cech integralności.",
    "sc_explainer_network_desc": "Oznacza ryzyka federacji, limitów szybkości i SMTP, zanim zaufanie zostanie błędnie wyświetlone.",
    "sc_open_security_warnings": "Otwarte ostrzeżenia bezpieczeństwa",
    "sc_opt_all": "Wszystkie",
    "sc_opt_low": "Niski",
    "sc_opt_medium": "Średni",
    "sc_opt_high": "Wysoki",
    "sc_opt_critical": "Krytyczny",
    "sc_opt_failed_login": "Błędne logowanie",
    "sc_opt_auth_attack": "Atak na autoryzację",
    "sc_opt_rate_limit": "Limit zapytań",
    "sc_opt_policy_violation": "Komunikat polityki",
    "sc_opt_message_replay": "Powtórzenie wiadomości",
    "sc_node_security_data_unavailable": "Dane bezpieczeństwa węzła niedostępne",
    "sc_total_events": "Suma zdarzeń",
    "sc_login_attacks": "Ataki na logowanie",
    "sc_rate_limits_active": "Aktywne limity szybkości",
    "sc_smtp_shield_hits": "Trafienia tarczy SMTP Shield",
    "sc_top_event_categories": "Najważniejsze kategorie zdarzeń",
    "sc_no_entries": "Brak wpisów.",
    "sc_node_audit_log": "Dziennik audytu węzła (ostatnie)",
    "sc_no_node_events": "Brak zdarzeń węzła.",
    "archiv": "Archiwum",
    "entwuerfe": "Szkice",
    "markiert": "Oznaczone gwiazdką",
    "wichtig": "Ważne",
    "snoozed": "Odroczone",
    "papierkorb": "Kosz",
    "spam": "Spam",
    "cancel": "Anuluj",
    "error": "Błąd",
    "success": "Sukces",
    "kopieren": "Kopiuj",
    "block_contact": "Zablokuj kontakt",
    "unblock_contact": "Odblokuj kontakt",
    "report_contact": "Zgłoś kontakt",
    "check_fingerprint": "Zweryfikuj odcisk palca",
    "export_encrypted": "Eksportuj (Zaszyfrowane)",
    "export_gaiaproof": "Eksportuj (GaiaProof)",
    "export_password_prompt": "Wprowadź hasło, aby zaszyfrować eksport czatu:",
    "export_success": "Czat został pomyślnie wyeksportowany i zaszyfrowany.",
    "export_failed": "Eksport nie powiódł się: ",
    "gaiaproof_export_success": "Pakiet GaiaProof został pomyślnie wyeksportowany.",
    "gaiaproof_export_failed": "Eksport GaiaProof nie powiódł się: ",
    "export_gaiaproof_confirm": "Czy chcesz pobrać pakiet GaiaProof ze wszystkimi podpisami i dowodami doręczenia serwera? To może chwilę potrwać.",
    "group_settings_is_private": "Pokój prywatny (niewyszukiwalny publicznie, tylko na zaproszenie/prośbę)",
    "group_settings_read_only": "Tryb tylko do odczytu (tylko właściciel i administratorzy mogą wysyłać wiadomości)",
    "group_settings_slow_mode": "Tryb powolny (opóźnienie wysyłania)",
    "gsn_title": "Kanał społecznościowy GSN",
    "gsn_node_feed": "Kanał węzła",
    "gsn_following_feed": "Obserwowani",
    "gsn_feed_empty": "Nie znaleziono wpisów.",
    "gsn_composer_placeholder": "Co nowego w federacji?",
    "gsn_post_btn": "Udostępnij",
    "gsn_profile": "Profil użytkownika",
    "gsn_followers": "Obserwujący",
    "gsn_following": "Obserwowani",
    "gsn_bio": "Opis / Biografia:",
    "gsn_bio_label": "Opis / Biografia",
    "gsn_display_name": "Nazwa wyświetlana",
    "gsn_edit_profile": "Edytuj profil",
    "gsn_save_profile": "Zapisz",
    "gsn_add_image": "Dodaj obraz (Zaszyfrowany)",
    "gsn_add_emoji": "Wstaw emoji",
    "gsn_avatar_emoji": "Awatar (Emoji)",
    "gsn_follow": "Obserwuj",
    "gsn_unfollow": "Odblokuj",
    "gsn_repost": "Udostępnij / Prześlij dalej",
    "gsn_post_created": "Wpis został pomyślnie udostępniony.",
    "gsn_image_uploaded": "Obraz został zaszyfrowany i przesłany.",
    "gsn_upload_failed": "Przesyłanie obrazu nie powiodło się: ",
    "gsn_comment_placeholder": "Napisz komentarz...",
    "gsn_delete_confirm_title": "Usunąć wpis?",
    "gsn_delete_confirm_desc": "Czy na pewno chcesz na stałe usunąć ten wpis?",
    "gsn_delete_comment_confirm_title": "Usunąć komentarz?",
    "gsn_delete_comment_confirm_desc": "Czy na pewno chcesz na stałe usunąć ten komentarz?",
    "gsn_report": "Zgłoś",
    "gsn_report_title": "Zgłoś naruszenie",
    "gsn_report_category": "Kategoria",
    "gsn_report_spam": "Spam / Reklama",
    "gsn_report_harassment": "Nękanie / Mowa nienawiści",
    "gsn_report_abuse": "Nadużycie",
    "gsn_report_illegal": "Treści nielegalne",
    "gsn_report_severity": "Stopień ważności",
    "gsn_report_low": "Niski",
    "gsn_report_medium": "Średni",
    "gsn_report_high": "Wysoki",
    "gsn_report_comment": "Dodatkowy komentarz",
    "gsn_report_submit": "Zgłoś",
    "gsn_report_submitted": "Zgłoszenie zostało przesłane do administracji.",
    "gsn_report_post": "Zgłoś wpis",
    "report_group": "Zgłoś grupę",
    "report_group_reason_prompt": "Wprowadź powód zgłoszenia (opcjonalnie):",
    "report_reason_prompt": "Wprowadź powód zgłoszenia (opcjonalnie):",
    "report_failed": "Zgłoszenie nie powiodło się: ",
    "report_success": "Kontakt został pomyślnie zgłoszony.",
    "room_read_only_placeholder": "Tylko właściciel i administratorzy mogą pisać",
    "read_only_active": "Tryb tylko do odczytu",
    "slow_mode_active": "Tryb powolny aktywny",
    "kommandozentrale": "Centrum dowodzenia",
    "kontakt_blockiert": "Kontakt zablokowany",
    "kontakt_freigegeben": "Kontakt odblokowany",
    "mailbox_settings_title": "Ustawienia skrzynki pocztowej",
    "mailbox_settings_desc": "Zarządzaj podpisem, językiem, filtrami poczty.",
    "mic_access_denied": "Odmowa dostępu do mikrofonu: ",
    "no_frequencies_active_desc": "Utwórz nowy pokój, aby rozpocząć komunikację.",
    "key_changed_warning_title": "OSTRZEŻENIE O BEZPIECZEŃSTWIE:",
    "key_changed_warning_desc": "Klucz tożsamości tego nadawcy został zaktualizowany lub różni się od wcześniej znanego. Zweryfikuj odcisk palca innym bezpiecznym kanałem.",
    "sc_col_category": "Kategoria",
    "search_members": "Wyszukaj członków...",
    "tab_general": "Ogólne",
    "tab_members": "Członkowie",
    "tab_requests": "Prośby",
    "tab_invites": "Zaproszenia",
    "tab_logs": "Dzienniki",
    "auth_why_gaiacom": "Dlaczego GaiaCOM?",
    "auth_why_gaiacom_desc": "Bezpieczna, scentralizowana alternatywa dla Twojej poufnej komunikacji.",
    "auth_self_managed_id": "Samodzielny identyfikator",
    "auth_self_managed_id_desc": "Natychmiast twórz bezpieczne tożsamości kryptograficzne bez podawania adresu e-mail czy telefonu.",
    "auth_gaiadrop_secure_exchange": "Bezpieczna wymiana bez konta",
    "auth_gaiadrop_benefit_e2ee": "Szyfrowanie typu end-to-end",
    "auth_gaiadrop_benefit_no_login": "Logowanie nie jest wymagane",
    "auth_gaiadrop_benefit_inbox": "Bezpośrednie doręczenie do skrzynki odbiorcy",
    "auth_terms_of_use": "Warunki korzystania",
    "auth_terms_of_use_show": "Pokaż warunki korzystania",
    "auth_consent_privacy_terms": "Przeczytałem i akceptuję politykę prywatności oraz warunki korzystania.",
    "auth_recovery_import_file": "Importuj plik odzyskiwania",
    "auth_recovery_password": "Hasło pliku odzyskiwania",
    "auth_recovery_local_password": "Nowe lokalne hasło odblokowujące min. 12 znaków",
    "auth_recovery_decrypting": "Deszyfrowanie odzyskiwania...",
    "auth_recovery_back": "Powrót do logowania",
    "auth_cookie_sovereign": "GaiaCOM pozostaje suwerenny.",
    "auth_cookie_sovereign_desc": "Używamy wyłącznie niezbędnych technicznie funkcji lokalnego przechowywania w celu obsługi języka, sesji i bezpieczeństwa. Brak śledzenia, brak reklamowych plików cookie, brak profili stron trzecich.",
    "auth_cookie_sovereign_accept": "Rozumiem",
    "unlock_keyboard_toggle": "⌨️ Użyj klawiatury",
    "unlock_keypad_toggle": "🔢 Użyj klawiatury PIN",
    "unlock_status_denied": "ODMOWA DOSTĘPU / SPRÓBUJ PONOWNIE",
    "unlock_status_decrypting": "DESZYFROWANIE KASAFORTY...",
    "unlock_status_secured": "KASAFORTA ZABEZPIECZONA / ZABLOKOWANA",
    "auth_landing_nav_legal": "Kwestie Prawne",
    "auth_landing_nav_beta": "Test Beta",
    "auth_landing_card1_title": "Kryptografia Post-Kwantowa (ML-KEM)",
    "auth_landing_card2_title": "100% Zdecentralizowane",
    "auth_landing_card3_title": "Wiedza Zerowa (Zero-Knowledge)",
    "auth_landing_card4_title": "Ochrona Metadanych",
    "auth_landing_card5_title": "Samodzielna Tożsamość (ID)",
    "auth_landing_hybrid_title": "Dzisiejsza kryptografia plus ochrona przed zagrożeniami jutra.",
    "auth_landing_hybrid_desc": "GaiaCom łączy sprawdzone, klasyczne protokoły wymiany kluczy z bezpiecznym szyfrowaniem post-kwantowym. Bez kompromisów — pełne bezpieczeństwo.",
    "auth_landing_x25519_desc": "Szybka i sprawdzona wymiana kluczy oparta na krzywych eliptycznych dla współczesnych urządzeń.",
    "auth_landing_mlkem_desc": "Post-kwantowa hermetyzacja kluczy chroniąca przed zagrożeniami typu przechwyć teraz, odszyfruj później.",
    "auth_landing_cycle_title": "Serwer nic nie widzi. Sieć przenosi jedynie szum.",
    "auth_landing_step1_title": "Lokalne Szyfrowanie",
    "auth_landing_step1_desc": "Wiadomość jest szyfrowana bezpośrednio na urządzeniu nadawcy, zanim trafi do sieci.",
    "auth_landing_step2_title": "Transport jako Blob",
    "auth_landing_step2_desc": "Pakiet przesyłany jest jako szum kryptograficzny przez rozproszone węzły i warstwy pamięci.",
    "auth_landing_step3_title": "Zdecentralizowane Przechowywanie",
    "auth_landing_step3_desc": "Brak centralnej bazy danych. Dane są pofragmentowane, w pełni zaszyfrowane i rozproszone.",
    "auth_landing_step4_title": "Lokalne Odszyfrowanie",
    "auth_landing_step4_desc": "Tylko prywatny klucz odbiorcy pozwala na odczytanie zaszyfrowanego pakietu.",
    "auth_landing_trinity_title": "Jeden protokół. Trzy poziomy infrastruktury.",
    "auth_landing_enterprise_desc": "Dla korporacji, kancelarii prawnych, MŚP i bankowości prywatnej. Zamknięte środowiska komunikacyjne z kontrolą administratora.",
    "auth_landing_enterprise_list1": "Pełna suwerenność i zaawansowane zarządzanie użytkownikami",
    "auth_landing_enterprise_list2": "Dedykowany węzeł serwerowy (self-hosted lub managed)",
    "auth_landing_enterprise_list3": "Gwarancja SLA, pełne wsparcie i moduły Premium",
    "auth_landing_network_desc": "Otwarta sieć chroniąca prywatność. Brak handlu danymi. Infrastruktura do darmowej i bezpiecznej komunikacji.",
    "auth_landing_network_list1": "Otwarty kod źródłowy aplikacji klienckiej",
    "auth_landing_network_list2": "Federacyjne węzły sieciowe",
    "auth_landing_network_list3": "Brak centralnego klucza deszyfrującego",
    "auth_landing_defend_desc": "Wysoce zabezpieczona infrastruktura dla instytucji rządowych i odizolowanych silosów komunikacyjnych.",
    "auth_landing_defend_list1": "Wdrożenia w środowiskach odizolowanych fizycznie (air-gapped)",
    "auth_landing_defend_list2": "Możliwość modyfikacji wizualnej i audyt kodu źródłowego",
    "auth_landing_defend_list3": "Krajowa suwerenność cyfrowa",
    "auth_landing_gov_title": "Otwarty protokół. Działalność komercyjna. Jasny podział prawny.",
    "auth_landing_gov_desc": "GaiaCom rozdziela otwarty protokół, wolne aplikacje i komercyjną strukturę premium. Zaufanie budowane jest przez pełną przejrzystość.",
    "auth_landing_price1_desc": "Opłata instalacyjna chroniąca przed botami w sklepach mobilnych.",
    "auth_landing_price2_desc": "Darmowe rozwiązanie dla osób samodzielnie kompilujących kod.",
    "auth_landing_price3_desc": "Dla średnich firm, kancelarii prawnych oraz zespołów dbających o prywatność.",
    "auth_landing_price4_desc": "Dla korporacji, klastrów HA, integracji z LDAP i dostępu administracyjnego.",
    "auth_landing_license1_desc": "Pełna transparentność kodu źródłowego dla audytów i społeczności.",
    "auth_landing_license2_desc": "Licencja copyleft zabezpieczająca przed komercyjnym zamknięciem protokołu.",
    "auth_landing_license3_desc": "Integracje LDAP, audyt, SLA i dedykowana logika biznesowa.",
    "auth_landing_final_title": "Komunikacja oparta na braku zaufania.",
    "auth_landing_final_desc": "GaiaCom nie tylko zastępuje e-maile. Zmusza do refleksji, dlaczego poufne dane wciąż są przechowywane na czytelnych serwerach opartych na technologii sprzed 40 lat.",
    "auth_landing_final_note": "Uwaga: Strona przedstawia wizję architektury i plan rozwoju. Gwarancje bezpieczeństwa wymagają wdrożenia i audytów przed zastosowaniem produkcyjnym."




  };

export default pl;